// @flow strict

const getTweetingUrl = (contact: string, url: string, postSlug: string) =>
  `https://twitter.com/intent/tweet?text=Check out this article by @${contact}&url=${url}${postSlug}`;

export default getTweetingUrl;
